/**
 * Central place for all data-testid strings.
 */
export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  handTrigger: "login-hand-trigger",
  authPopup: "auth-popup",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  pinInput: "login-pin-input",
  loginSubmit: "login-submit-btn",
  pinLoginSubmit: "pin-login-submit-btn",
  tabPassword: "auth-tab-password",
  tabPin: "auth-tab-pin",
  rememberDevice: "auth-remember-device",
  logoutBtn: "header-logout-btn",
};

export const DASH = {
  root: "dashboard-root",
  kpiSales: "kpi-today-sales",
  kpiProfit: "kpi-today-profit",
  kpiCollection: "kpi-today-collection",
  kpiOutstanding: "kpi-outstanding",
  kpiInventory: "kpi-inventory-value",
  kpiCash: "kpi-cash-balance",
  kpiBank: "kpi-bank-balance",
  kpiUpi: "kpi-upi-balance",
  chartSales: "chart-sales-trend",
  chartMode: "chart-payment-mode",
  recentBills: "recent-bills-table",
  recentExpenses: "recent-expenses-table",
  lowStock: "low-stock-list",
  floatingBillBtn: "floating-bill-hand",
  quickBill: "quick-action-bill",
  quickExpense: "quick-action-expense",
  quickPurchase: "quick-action-purchase",
  quickCustomer: "quick-action-customer",
  quickReports: "quick-action-reports",
  quickSupplier: "quick-action-supplier",
  globalSearch: "global-search-input",
};

export const INVOICE = {
  modal: "invoice-modal",
  customerName: "invoice-customer-name",
  customerMobile: "invoice-customer-mobile",
  customerGstin: "invoice-customer-gstin",
  customerAddress: "invoice-customer-address",
  customerType: "invoice-customer-type",
  productSearch: "invoice-product-search",
  productResult: (id) => `invoice-product-result-${id}`,
  addItem: "invoice-add-item",
  itemQty: (idx) => `invoice-item-qty-${idx}`,
  itemRate: (idx) => `invoice-item-rate-${idx}`,
  itemDiscount: (idx) => `invoice-item-discount-${idx}`,
  removeItem: (idx) => `invoice-item-remove-${idx}`,
  next: "invoice-next-btn",
  back: "invoice-back-btn",
  paymentMode: (id) => `payment-mode-${id}`,
  paymentAmount: "payment-amount-received",
  paymentSubmit: "invoice-submit-btn",
  printInvoice: "invoice-print-btn",
  downloadPdf: "invoice-download-pdf-btn",
  newBill: "invoice-new-bill-btn",
  closeModal: "invoice-modal-close",
};
